import { useState } from 'react';
import { Tabs } from 'antd';
import {
    AppstoreOutlined, SettingOutlined, ShoppingOutlined,
} from '@ant-design/icons';
import OneOrders from './OneOrders';
import OneSettings from './OneSettings';
import OnePartnerApps from './OnePartnerApps';


/**
 * YouGuide One — the mobile app and the website's /new-esims page.
 *
 * Three tabs rather than three sidebar entries: they are one product, and an
 * operator moving between "what did this order cost us" and "is the markup
 * right" should not be navigating the panel to do it.
 */
export default function YouGuideOne() {
    const [tab, setTab] = useState('orders');

    return (
        <div style={{ padding: 24 }}>
            {/* The page title and strapline are gone. The sidebar already
                names this page, and the tabs below name what is on it — a
                heading that repeats the navigation is a row of vertical space
                that pushes the actual orders below the fold. */}
            <Tabs
                activeKey={tab}
                onChange={setTab}
                items={[
                    {
                        key: 'orders',
                        label: <span><ShoppingOutlined /> Orders</span>,
                        children: <OneOrders />,
                    },
                    {
                        key: 'settings',
                        label: <span><SettingOutlined /> Pricing &amp; limits</span>,
                        children: <OneSettings />,
                    },
                    {
                        key: 'partners',
                        label: <span><AppstoreOutlined /> Partner apps</span>,
                        children: <OnePartnerApps />,
                    },
                ]}
                // Each tab fetches on mount; destroying them means a return to a
                // tab shows current data rather than a stale snapshot. Orders and
                // margins change while the panel is open.
                destroyInactiveTabPane
            />
        </div>
    );
}
